import { useQuery } from "@tanstack/react-query";
import { ENDPOINTS } from "@/api/application-api";
import { authHeader } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { useUserToken } from "@/context/auth-context";
import { displayErrorToast } from "@/utils/toast";

export interface MCPFunction {
  name: string;
  description: string;
  input_schema: Record<string, object>;
}

export const useListMCPFunctions = (
  serverUrl: string | undefined,
  headers: Record<string, string> | undefined,
) => {
  const userToken = useUserToken();

  let headerKey =
    headers === undefined
      ? ""
      : Object.entries(headers)
          .map((header) => header[0] + "=" + header[1])
          .join("&");

  return useQuery<MCPFunction[]>({
    queryKey: ["listMCPFunctions", serverUrl, headerKey],
    enabled: serverUrl !== undefined,
    queryFn: async () => {
      const url = new URL(ENDPOINTS.list_mcp_functions);
      const response = await fetch(url.toString(), {
        method: "POST",
        headers: authHeader(userToken),
        body: JSON.stringify({
          server_configuration: {
            server_url: serverUrl,
            headers: headers,
          },
        }),
      });
      return handleResponse(response).catch((err) => displayErrorToast(err));
    },
  });
};
